import React from 'react'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { HomeStack } from 'navigation/home-stack'
import { FeedStack } from 'navigation/feed-stack'
import { MyPageStack } from 'navigation/mypage-stack'
import Ionicons from 'react-native-vector-icons/Ionicons'
import { getFocusedRouteNameFromRoute } from '@react-navigation/native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { colors } from 'infra/color'

const Tab = createBottomTabNavigator()

const getTabBarVisibility = (route: any) => {
  const routeName = getFocusedRouteNameFromRoute(route)
  if (!routeName) return true
  const rootScreens = ['HomeScreen', 'FeedScreen', 'UserDetailScreen']
  return rootScreens.includes(routeName)
}

export const BottomTabs = () => {
  const insets = useSafeAreaInsets()
  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        headerShown: false,
        tabBarShowLabel: false,
        tabBarActiveTintColor: colors.primary,
        tabBarStyle: getTabBarVisibility(route)
          ? {
              height: 60 + Math.max(insets.bottom - 10, 0),
              paddingBottom: Math.max(insets.bottom - 10, 0),
              paddingTop: 6,
            }
          : { display: 'none' as const },
        // The navigator API requires a render callback and supplies focus state.
        // eslint-disable-next-line react/no-unstable-nested-components
        tabBarIcon: ({ color, size, focused }) => {
          const icons: Record<string, string> = {
            HomeTab: focused ? 'map' : 'map-outline',
            FeedTab: focused ? 'reader' : 'reader-outline',
            MyPageTab: focused ? 'person' : 'person-outline',
          }
          return <Ionicons name={icons[route.name]} size={size} color={color} />
        },
      })}
    >
      <Tab.Screen name='HomeTab' component={HomeStack} />
      <Tab.Screen name='FeedTab' component={FeedStack} />
      <Tab.Screen name='MyPageTab' component={MyPageStack} />
    </Tab.Navigator>
  )
}
